module.exports = __webpack_public_path__ + "img/scene5-20.e2674d12.png";